var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F8F7FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "#534FA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 58.625L65.125 50.5M65.125 50.5L57 42.375M65.125 50.5H45.625M45.625 35.875H43.675C40.9447 35.875 39.5796 35.875 38.5368 36.4063C37.6195 36.8737 36.8737 37.6195 36.4063 38.5368C35.875 39.5796 35.875 40.9447 35.875 43.675V57.325C35.875 60.0553 35.875 61.4204 36.4063 62.4632C36.8737 63.3805 37.6195 64.1263 38.5368 64.5937C39.5796 65.125 40.9447 65.125 43.675 65.125H45.625",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.194c88de91250721e596abc7864f52b6.svg";
export { ForwardRef as ReactComponent };